import React from 'react';

const UserLoginForm = ({ 
  email, 
  password, 
  errorMessage, 
  loading, 
  formSubmitted, 
  handleEmailChange, 
  handlePasswordChange, 
}) => {
  return (
    <form>
      <div className="modal-column">
        <div className="form-group">
          <input
            type="email"
            value={email}
            onChange={handleEmailChange}
            placeholder="Email"
            maxLength="255"
            className={formSubmitted && !email ? 'missing-field' : ''}
          />
          <div className="error-message-container">
            {formSubmitted && !email && <p className="error-message">Email is required</p>}
          </div>
        </div>

        <div className="form-group">
          <input
            type="password"
            value={password}
            onChange={handlePasswordChange}
            placeholder="Password"
            maxLength="255"
            className={formSubmitted && !password ? 'missing-field' : ''}
          />
          <div className="error-message-container">
            {formSubmitted && !password && <p className="error-message">Password is required</p>}
          </div>
        </div>

        {errorMessage && (
          <div className="error-message-container">
            <p className="error-message">{errorMessage}</p>
          </div>
        )}
      </div>
    </form>
  );
};

export default UserLoginForm;